import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { BehaviorService } from '@_services/Behavior.service';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ServerErrorComponent implements OnInit, OnDestroy {
  timeData: any;
  sub1: Subscription;
  constructor(
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService,
    public behaviorService: BehaviorService,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.timeData = setInterval(() => this.checkserver(), 6000);
  }

  checkserver() {
    this.sub1 = this.http
      .post<any>(environment.APIEndpointDeliverable + 'login', {
        request: 'maintainlicence',
        BACKGROUND: true,
      })
      .subscribe({
        next: (loginResponse) => {
          this.behaviorService.dialogClose(loginResponse);
          if (
            loginResponse.MESSAGE == 'Not logged in' ||
            (loginResponse.STATUS == '' && loginResponse.MESSAGE == '')
          ) {
            this.router.navigate(['login']);
          } else if (loginResponse.STATUS == 'success') {
            let defult_routeData: any = JSON.parse(localStorage.getItem('defult_routeData'))
              ? JSON.parse(localStorage.getItem('defult_routeData'))
              : ['matters'];
            this.router.navigate(defult_routeData);
          }
        },
        error: (error) => {
          this.toastr.error(error?.message || 'Server error');
        },
      });
  }

  ngOnDestroy(): void {
    clearInterval(this.timeData);
    this.sub1?.unsubscribe();
  }
}
